const textLight = {
    primary: 'rgba(52, 49, 76, 1)',
    secondary: 'rgba(52, 49, 76, 0.54)',
    disabled: 'rgba(52, 49, 76, 0.38)',
    hint: 'rgba(52, 49, 76, 0.38)',
}

const textUniversity = {
    primary: 'rgba(0,0,0, 1)',
    sidenaveTextColor: 'rgba(255,255,255, 1)',
    secondary: 'rgba(52, 49, 76, 0.54)',
    disabled: 'rgba(52, 49, 76, 0.38)',
    hint: 'rgba(52, 49, 76, 0.38)',
}


const secondaryColor = {
    light: '#f9a352',
    main: '#ff9e43',
    dark: '#ff932e',
    contrastText: textLight.primary,
}
const errorColor = {
    main: '#FF3D57',
}

export const themeColors = {

    slateDark1: {
        palette: {
            type: 'dark',
            primary: {
                main: '#222A45',
                contrastText: '#ffffff',
            },
            secondary: {
                main: '#ff9e43',
                contrastText: textLight.primary,
            },
            error: errorColor,
            background: {
                paper: '#222A45',
                default: '#1a2038',
            },
        },
    },

    blue: {
        palette: {
            zoom:'0.9',
            type: 'light',
            primary: {
                main: '#567F4F',
                contrastText: '#ffff',
            },
            secondary: {
                main: '#FFAF38',
                contrastText: textLight.primary,
            },
            light: {
                main: '#1a73e8',
                contrastText: '#ffffff',
            },

            error: errorColor,
            text: textUniversity,
            subTitleTextColor: '#494848',
            background: {
                paper: '#ffffff',
                default: '#f5f8f8',
            },
            menuBackgroundColor: {//top bar styles
                main: '#FFFFFF',
                startColor:'#FFFFFF',
                endColor:'#FFFFFF',
                contrastText: '#494848',
                iconColor:'#f3aa1f'

            },

            sideNav: {
                type: 'light',
                primary: {
                    main: 'white',//backgroud color 
                    mainTop: '#ffffff',//backgroud color top
                    mainBotomn:'#fffffff0',
                    contrastText: '#A0AEC0',//lable color
                    contrastTextActive: '#2D3748',//active tab lable color
                },
                secondary: {
                    main: '#717272',
                    contrastText: '#ffffff',
                },
                sideNavIcon: {
                    main: '#24AB70',//icon normal color
                    activeColor: 'white',//icon Active color  #079de5
                },
                text: textLight,
            },
            footer: {
                main: '#ffffff',//backgroud color
                contrastText: '#494848',//lable color
            },
            textInput: {
                background: '#f0f2f2'
            },
            table: {
                head: { background: '#DCF1D3'}, 
                oddRowColor:'white'
            },
            bannerBackgroundColor:'rgb(6 189 228 / 46%)'


        },
    },

}
